import {Centre} from "../styled/Center.styled";

function More(props) {
    return <Centre>
    <h1>More Features</h1>
    <p>To be added soon!!!</p>
</Centre>;
}

export default More;